import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { postBlogList } from "../../../../services/CommonService";
import Pagination from "react-js-pagination";
import { Helmet } from 'react-helmet-async';

function Blog() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [blogList, setBlogList] = useState([]);
    const [blogCount, setBlogCount] = useState(0);
    const [page, setPage] = useState(1);

    useEffect(function () {
        setLoading(true);
        let obj = {
            limit: 9,
            page: page
        };
        postBlogList(obj)
            .then(response => {
                setBlogList(response.data.data);
                setBlogCount(parseInt(response.data.count));
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
            });
    }, [page]);

    const someDefinedVariable = "AI-Powered Document Management | Secure & Automated Workflow";


    return (
        <>
            <Helmet>
                <title>{someDefinedVariable || "Default Title"}</title>
                <meta name='description' content='Boost productivity with DocuSafe, an AI-powered document management system featuring automation, real-time tracking, seamless integrations & enterprise-grade security. Optimize workflow effortlessly!' />
                <meta name='keywords' content='AI document management, automated document workflow, secure file storage, enterprise document security, real-time document tracking, cloud document automation, AI-powered file management, seamless business integrations, smart document organization, digital document security' />
            </Helmet>
            <div className="p-0" style={{ minHeight: 'calc(100vh - 374px)' }}>
                {loading && <div className="page-loading">
                    <img src="/images/loader.gif" alt="loader" />
                </div>}
                <div className="title_container  px-4 py-5">
                    <h1 className="text-white text-center mb-3 mt-5">Blog</h1>
                    <p className="text-white text-center">Check this page for regular Blog posts by the Docusafe.ai Team.</p>
                </div>
                <div className=" custom_container py-5 px-3 ">
                    <div className="row mb-3">
                        {blogList.map((item, index) =>
                            <div key={index} className="col-lg-4 mb-3">
                                <NavLink to={"/blog/" + item.blog_url} className="text-decoration-none">
                                    <div className="card blog_card">
                                        <div className="blog_img">
                                            <img src={item.image} alt="..." className="w-100 " />
                                        </div>
                                        <div className="card-body">
                                            <p className="mb-3" style={{ fontSize: "18px", fontWeight:'bold' }}>{item.title}</p>
                                            {/* <h5 className="mb-2" style={{ fontSize: '15px', color: '#adadad' }}>{item.author_name + `-` + item.created_at}</h5> */}
                                            <h5 className="mb-2 d-flex align-items-center" style={{ fontSize: '15px', color: '#adadad' }}>
                                                <i className="bi bi-person-circle me-2"></i>
                                                {item.author_name}
                                                <span className="mx-2">–</span>
                                                <span>{item.created_at}</span>
                                            </h5>

                                        </div>
                                    </div>
                                </NavLink>
                            </div>
                        )}

                        {blogList.length === 0 && (
                            <div className="col-lg-12">
                                <div className="mt-4 py-3 bg-primary text-white text-center">
                                    <h6>No Blog Available.</h6>
                                </div>
                            </div>
                        )}
                    </div>

                    {blogList.length > 0 && (
                        <ul className="pagination blog-pagination ps-0 align-items-center justify-content-center flexWrap mb-5">
                            <Pagination
                                activePage={page}
                                itemsCountPerPage={9}
                                totalItemsCount={parseInt(blogCount)}
                                pageRangeDisplayed={5}
                                onChange={(e) => setPage(e)}
                            />
                        </ul>
                    )}
                    {/* <div
                        className="appointment-div d-flex align-items-center justify-content-center px-4 py-5  border_radius flexWrap">
                        <h2 className="text-white me-4 text-center">Having any Query ? Contact us.</h2>
                        <button type="button" onClick={(e) => navigate('/contact')}
                            className="btn book-now bg-primary text-white">Contact us
                        </button>
                    </div> */}
                </div>
            </div>
        </>
    );
}

export default Blog;